<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "purchaseManage",
        components: {},
        data() {
            return {}
        },
        mounted() {

        },
        methods: {},
    }
</script>

<style lang="scss" scoped>

</style>